import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const Step = (props) => {
  const { t, data } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={data.isActive ? 1 : "0.2"}>
        {data.step === 1 && (
          <ColumnButton
            border="#0A4986"
            background="#0A4986"
            marginRight="10px"
          >
            {t("ENQUIRY_STATUS_TO_PROCESS")}
          </ColumnButton>
        )}
        {data.step === 2 && (
          <ColumnButton
            border="#F08046"
            background="#F08046"
            marginRight="10px"
          >
            {t("ENQUIRY_STATUS_QUOTATION")}
          </ColumnButton>
        )}
        {data.step === 4 && (
          <ColumnButton
            border="#E83F1E"
            background="#E83F1E"
            marginRight="10px"
          >
            {t("ENQUIRY_STATUS_DELETED")}
          </ColumnButton>
        )}
        {data.step === 6 && (
          <ColumnButton
            border="#CCCCCC"
            background="#CCCCCC"
            marginRight="10px"
          >
            {t("ENQUIRY_STATUS_CANCELED")}
          </ColumnButton>
        )}
        {data.step === 5 && (
          <ColumnButton
            border="#32A728"
            background="#32A728"
            marginRight="10px"
          >
            {t("ENQUIRY_STATUS_QUOTED")}
          </ColumnButton>
        )}
        {data.step === 9 && (
          <ColumnButton
            border="#F08046"
            background="#F08046"
            marginRight="10px"
          >
            {t("ENQUIRY_STATUS_REQUOTATION")}
          </ColumnButton>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

Step.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Step);
